(() => {
  const TABLE_SELECTOR = '.bss-b2b-cart-item-qty-table, .bss-b2b-qty-table-wrapper table';
  const POLL_MS = 400;

  const normalizeNumber = (str) => parseFloat(str.replace(/\.(?=\d{3}(\D|$))/g, '').replace(',', '.'));

  const parseTiers = (table) => {
    const tiers = [];
    table.querySelectorAll('tr').forEach((row) => {
      const text = row.textContent.replace(/\s+/g, ' ').trim();
      const euroIndex = text.indexOf('€');
      if (euroIndex === -1) return;

      const qtyMatch = text.slice(0, euroIndex).match(/\d+/);
      const priceMatch = text.slice(euroIndex + 1).match(/[\d.,]+/);
      if (!qtyMatch || !priceMatch) return;

      const minQty = parseInt(qtyMatch[0], 10);
      const price = normalizeNumber(priceMatch[0]);
      if (isNaN(minQty) || isNaN(price)) return;

      tiers.push({ minQty, price });
    });

    return tiers.sort((a, b) => a.minQty - b.minQty);
  };

  const formatSavings = (amount) => amount.toFixed(2).replace('.', ',').replace(/,00$/, '');

  const buildMessage = (el, quantityInput, tiers) => {
    if (tiers.length < 2) return null;

    const qty = parseInt(quantityInput.value, 10) || 1;
    const baseTier = tiers[0];
    let currentTier = baseTier;
    let nextTier = null;
    for (const tier of tiers) {
      if (tier.minQty <= qty) currentTier = tier;
      else {
        nextTier = tier;
        break;
      }
    }

    // Already inside a discounted tier: confirm the total saved on this order.
    if (currentTier !== baseTier) {
      const totalSavings = Math.round((baseTier.price - currentTier.price) * qty * 100) / 100;
      if (totalSavings <= 0) return null;
      return {
        active: true,
        text: (el.dataset.activeMessageTemplate || '').replace('{savings}', formatSavings(totalSavings)),
      };
    }

    // Still in the base tier: nudge toward the next discount threshold.
    if (!nextTier) return null;
    const remaining = nextTier.minQty - qty;
    const savingsPerUnit = Math.round((currentTier.price - nextTier.price) * 100) / 100;
    if (remaining <= 0 || savingsPerUnit <= 0) return null;

    return {
      active: false,
      text: (el.dataset.messageTemplate || '')
        .replace('{remaining}', remaining)
        .replace('{unit}', el.dataset.unit || '')
        .replace('{savings}', formatSavings(savingsPerUnit)),
    };
  };

  // Only touches the DOM when something actually changed, so this can never
  // trigger itself again via a mutation observer or similar.
  const render = (el, textEl, message) => {
    if (message === null) {
      if (!el.hidden) el.hidden = true;
      return;
    }
    if (textEl.textContent !== message.text) textEl.textContent = message.text;
    if (el.hidden) el.hidden = false;
    if (el.classList.contains('is-active') !== message.active) {
      el.classList.toggle('is-active', message.active);
    }
  };

  const init = (el) => {
    const quantityInput = document.getElementById('Quantity');
    const textEl = el.querySelector('[data-bulk-discount-hint-text]');
    if (!quantityInput || !textEl) return;

    let table = null;

    const tick = () => {
      if (!table) {
        table = document.querySelector(TABLE_SELECTOR);
        if (!table) return;
      }
      render(el, textEl, buildMessage(el, quantityInput, parseTiers(table)));
    };

    // The +/- buttons are Vue-driven and set the input's value
    // programmatically, which never fires native input/change events — so
    // this polls on an interval instead of relying on those events alone.
    // render() only touches the DOM when something actually changed, so
    // polling forever here is cheap and safe.
    setInterval(tick, POLL_MS);

    quantityInput.addEventListener('input', tick);
    quantityInput.addEventListener('change', tick);

    tick();
  };

  document.querySelectorAll('[data-bulk-discount-hint]').forEach(init);
})();
